import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCandidateReport,
  getCandidateDetails,
} from "src/services/Reports/CandidateReportService";
import { alertMessageState, loadingState } from "src/atom/LoadingState";
import { useSetRecoilState } from "recoil";
import Paginator from "src/components/Paginator";
import callApi from "src/services/Common/api";

const CandidateReport = () => {
  const searchObject = {
    size: 10,
    totalPages: 0,
    totalItems: 0,
    currentPage: 1,
    sortWith: "id",
    sortOrder: "asc",
    candidateName: "",
    registrationNumber: "",
    status: "",
  };

  const [paginatorData, setPaginatorData] = useState(searchObject);
  const [filters, setFilters] = useState({
    registrationNumber: "",
    candidateName: "",
    status: "",
  });
  const enableLoader = useSetRecoilState(loadingState);
  const [candidates, setCandidates] = useState();
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const navigate = useNavigate();

  const statusOptions = [
    { value: "", label: "All Status" },
    { value: "CONTINUE", label: "CONTINUE" },
    { value: "COMPLETED", label: "COMPLETED" },
  ];

  const nextPage = (pageNumber) => {
    setPaginatorData((previousData) => ({
      ...previousData,
      currentPage: pageNumber,
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    setPaginatorData((prev) => ({
      ...prev,
      ...filters,
      currentPage: 1, // Reset to first page when searching
    }));
  };

  const handleClear = () => {
    setFilters({
      registrationNumber: "",
      candidateName: "",
      status: "",
    });
    setPaginatorData((prev) => ({
      ...prev,
      registrationNumber: "",
      candidateName: "",
      status: "",
      currentPage: 1,
    }));
  };

  const fetchCandidatesApiCall = async (pageId) => {
    enableLoader(true);
    const responseData = await callApi(
      `/v1/api/registered-candidates/${pageId}`,
      "POST",
      paginatorData,
      true,
      setAlertMessage
    );
    if (responseData.success !== false) {
      if (responseData.body && Object.keys(responseData.body).length > 0) {
        setCandidates(responseData.body.candidates);
        setPaginatorData((previousData) => ({
          ...previousData,
          currentPage: +responseData?.body?.currentPage,
          size: +responseData?.body?.size,
          totalPages: +responseData?.body?.totalPages,
          totalItems: +responseData?.body?.totalItems,
          next: +responseData?.body?.currentPage + 1,
          prev: +responseData?.body?.currentPage - 1,
        }));
      }
    }
    enableLoader(false);
  };

  const fetchCandidateDetailsApiCall = async (pageId, candidateId) => {
    enableLoader(true);
    var url = `/v1/api/candidate-details/${pageId}/${candidateId}`;
    const responseData = await callApi(url, "GET", null, true, setAlertMessage);
    enableLoader(false);
    if (responseData.success !== false) {
      navigate("/preview-page", {
        state: {
          formData: responseData.body?.previewData,
          masterQuestions: responseData.body?.previewQuestions,
        },
      });
    } else {
      setAlertMessage(responseData.message);
    }
  };

  useEffect(() => {
    fetchCandidatesApiCall(2);
  }, [
    paginatorData?.currentPage,
    paginatorData?.size,
    paginatorData?.candidateName,
    paginatorData?.registrationNumber,
    paginatorData?.status,
  ]);

  return (
    <>
      <div className="card mb-4">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Candidate Application Reports</span>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Registration Number"
                name="registrationNumber"
                value={filters.registrationNumber}
                onChange={handleFilterChange}
              />
            </div>
            <div className="col-sm-3 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Candidate Name"
                name="candidateName"
                value={filters.candidateName}
                onChange={handleFilterChange}
              />
            </div>
            <div className="col-sm-3 mb-2">
              <select
                className="form-control"
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
              >
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-3 mb-2 d-flex">
              <button
                className="btn btn-success text-white mr-2"
                onClick={handleSearch}
                style={{ marginRight: "10px" }}
              >
                Search
              </button>
              <button
                className="btn btn-warning text-white"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover table-bordered">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Reg.No</th>
                  <th>Candidate Name</th>
                  <th>Status</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {candidates?.map((candidate, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{candidate.registrationNumber}</td>
                    <td>{candidate.candidateName}</td>
                    {candidate.status === "Submitted" ? (
                      <td style={{ color: "green" }}>{candidate.status}</td>
                    ) : (
                      <td style={{ color: "#CC7722" }}>{candidate.status}</td>
                    )}
                    <td>
                      {candidate.status === "Submitted" && (
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            fetchCandidateDetailsApiCall(2, candidate.id)
                          }
                        >
                          View Details
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <Paginator
            pagination={paginatorData}
            range={3}
            nextPage={nextPage}
            setPagination={setPaginatorData}
          />
        </div>
      </div>
    </>
  );
};

export default CandidateReport;
